import { useEffect } from 'react';
import type { AllocationsForShipper } from 'src/apis/lng-marketing/types';
import type { LngOfferDetailsRequest } from 'src/apis/lng-marketing/use-lng-offer-details';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  lngOfferDetails?: LngOfferDetailsRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useOptionalLngGetAllocationsForShipper({
  lngOfferDetails,
}: HookOptions) {
  const allocations = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) => {
      return axios.request<AllocationsForShipper>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!lngOfferDetails?.response) return;
    if (!lngOfferDetails.response.data._links.getAllocationsForShipper) return;
    allocations.execute({
      url: lngOfferDetails.response.data._links.getAllocationsForShipper.href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [lngOfferDetails?.response]);

  // not available on stage
  if (!lngOfferDetails) return;

  // no allocations (or not allowed to get it)
  if (
    lngOfferDetails.response &&
    !lngOfferDetails.response.data._links.getAllocationsForShipper
  )
    return;

  return allocations;
}

export type LngGetAllocationsForShipperRequest = ReturnType<
  typeof useOptionalLngGetAllocationsForShipper
>;
